(function ($){
    // global variables
    const BODY = $('body');

    // wish list toggle
    BODY.on('alg_wc_wl_toggle_wl_item', function (e){
        let that = $(e.target);
        let product_card =  that.parents('.product-card');
        let title = product_card.find('.product-card__title').text();
        let products_list = $('.products-list__col');
        let wishlist_not_found = $('.wishlist-not-found');
        let product_toast = new bootstrap.Toast('#product-toast');


        // remove item on wishlist page
        if(BODY.is('.woocommerce-my-wish-list')){
            that.parents('.products-list__col').remove();

            $('.shop-nav__icon-counter').on('DOMSubtreeModified', function (){
                let wishlist_length = parseInt($('.alg-wc-wl-counter').text());

                if(wishlist_length < 1){
                    wishlist_not_found.show();
                }
            });

        }

        // product toast
        if(that.is('.remove')){
            insert_to_product_toast('<b>' + title +'</b>' + TOAST_TEXT_ADD_TO_WISHLIST);
        } else {
            insert_to_product_toast('<b>' + title +'</b>' + TOAST_TEXT_REMOVE_FROM_WISHLIST);
        }

        product_toast.show();
    });
}(jQuery));
